import { render } from "./ManageUserFeatures.vue?vue&type=template&id=7765ab26"
import script from "./ManageUserFeatures.vue?vue&type=script&lang=js"
export * from "./ManageUserFeatures.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__